// extracted by mini-css-extract-plugin
module.exports = {"AnonMenu":"AnonMenu-module_AnonMenu_2R77M","login":"AnonMenu-module_login_2UqRX","register":"AnonMenu-module_register_2GP48","hamburgerOpen":"AnonMenu-module_hamburgerOpen_YcrIG"};